/* ═══════════════════════════════════════════════════════════════════════════
   selfIdentityWeb.js — the browser's half of "who am I, offline".

   The rules are shared: services/selfIdentity.js is generated from the phone's
   TypeScript and both clients ask it the same questions. What differs is where
   the answer is kept — localStorage here, AsyncStorage + a file on the phone.

   🟥 THE TAB HAD THE SAME HOLE THE PHONE DID, and it was wider. ProfilePanel
      opens `onSnapshot(users/<uid>)` and renders NOTHING until the first
      snapshot — `if (!me) return <empty panel>`. The web client keeps no
      Firestore persistence, so with no network that snapshot never arrives and
      the panel stays blank forever: not a wrong name, no panel at all.

   🟢 A record written on every snapshot makes the reload paint what it knew.

   🟥 NO FILE COPY HERE, ON PURPOSE. A tab cannot write to disk, and an avatar
      stuffed into localStorage as a data: URL would spend the origin's whole
      quota on one face. The browser's HTTP cache already serves the image on a
      reload; `file` stays '' and `selfAvatarSource` falls through to the remote
      URL, which is exactly what it does on a phone that has not downloaded one
      yet. One rule, two clients, different amounts of disk. */
import { SELF_IDENTITY_KEY, identityFrom, mergeIdentity, parseIdentity, identitySame, identityForUid } from './selfIdentity';

let _mem = null;
let _readTried = false;

/** Whatever we know, synchronously — localStorage is not a round trip. */
export function getSelfIdentity(uid) {
  if (!_readTried) {
    _readTried = true;
    try { _mem = mergeIdentity(parseIdentity(localStorage.getItem(SELF_IDENTITY_KEY)), _mem); } catch {}
  }
  return identityForUid(_mem, uid);
}

/** Write down what this snapshot told us. Silent when storage is unavailable. */
export function rememberSelfIdentity(uid, profile, authUser) {
  try {
    getSelfIdentity();                       // make sure a stored record is folded in first
    const next = mergeIdentity(_mem, identityFrom(uid, profile, authUser));
    if (!next || identitySame(_mem, next)) return;
    _mem = next;
    try { localStorage.setItem(SELF_IDENTITY_KEY, JSON.stringify(next)); } catch {}
  } catch {}
}

/** Sign-out: the next account must not inherit this one's face. */
export function forgetSelfIdentity() {
  _mem = null;
  _readTried = true;
  try { localStorage.removeItem(SELF_IDENTITY_KEY); } catch {}
}
